module.exports = __webpack_public_path__ + "media/media/values/michael-woodes-24f505d36283b48ee01dda023afd5fd1.jpg";